import {
  Box,
  Icon,
  Tooltip,
  useBoolean,
  useDisclosure,
} from '@wegroup/design-system';
import cogoToast from 'cogo-toast';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import usePartyId from '../../../../../../../common/src/hooks/query-params/usePartyId';
import { markFlowAsComplete } from '../../../../../../../sales-conversation/src/services/louiseApiService';
import useCompanyScanResetState from '../../../../../../../company-scan/hooks/useCompanyScanResetState';
import useFlowsResetState from '../../../../../hooks/useFlowsResetState';
import { useFlowsRouteParams } from '../../../../../hooks/useFlowsRouteParams';
import ToolbarIconButton from '../small-toolbar/ToolbarIconButton';
import ResetCompanyScanAlertDialog from './ResetCompanyScanAlertDialog';
import useTracking from '../../../../../../../common/src/hooks/tracking/useTracking';

const ResetCompanyScanToolbarButton: React.FC = () => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const history = useHistory();
  const { t } = useTranslation();
  const { reset: companyScanReset } = useCompanyScanResetState();
  const { reset: flowsReset } = useFlowsResetState();
  const hasUrlPartyId = !!usePartyId();
  const { sessionId } = useFlowsRouteParams();
  const [isLoading, setIsLoading] = useBoolean();
  const { trackEvent } = useTracking();

  const handleConfirm = async () => {
    trackEvent('Restarted conversation in Company Scan');
    if (!hasUrlPartyId && sessionId) {
      // complete flow
      setIsLoading.on();
      const [, status] = await markFlowAsComplete({
        conversationId: sessionId,
      });
      if (status >= 400)
        cogoToast.error(t('COMPANY-SCAN_RESTART_BUTTON_ERROR'));
      setIsLoading.off();
    }
    history.push('/company-scan');
    onClose();
    // reset redux
    companyScanReset();
    flowsReset();
  };

  const handleClick = () => {
    onOpen();
  };

  return (
    <Box pos="relative">
      <ResetCompanyScanAlertDialog
        isOpen={isOpen}
        onClose={onClose}
        onConfirm={handleConfirm}
        isLoading={isLoading}
      />
      <Tooltip
        label={t('CONVERSATIONS_RESTART')}
        placement="right"
        shouldWrapChildren
      >
        <ToolbarIconButton
          onClick={handleClick}
          aria-label="Restart"
          icon={
            <Icon
              name="GeneralActionsReset"
              color="secondary.300"
              boxSize="7"
            />
          }
        />
      </Tooltip>
    </Box>
  );
};

export default ResetCompanyScanToolbarButton;
